export function MascaraCep(value) {
    if (!value) return "";

    // Remove tudo que não é número
    value = value.replace(/\D/g, "");

    // Limita a 8 dígitos
    if (value.length > 8) value = value.slice(0, 8);

    // Aplica a máscara gradualmente: 99999-999
    if (value.length <= 5) {
        return value;
    }

    return value.replace(/^(\d{5})(\d{0,3})$/, "$1-$2");
}